import config from './config.data.json';

const isLocalHost =
  typeof window !== 'undefined' &&
  /^(localhost|127(?:\.\d{1,3}){3}|0\.0\.0\.0)$/i.test(window.location.hostname);

const hasEnvValue = (value) => typeof value === 'string' && value.trim() !== '';
const shouldUseDevProxy =
  process.env.NODE_ENV === 'development' &&
  isLocalHost &&
  hasEnvValue(process.env.REACT_APP_PROXY_TARGET);

export const API_URL = shouldUseDevProxy
  ? ''
  : hasEnvValue(process.env.REACT_APP_URL)
  ? process.env.REACT_APP_URL
  : isLocalHost
  ? ''
  : config.API_URL;
export const APP_URL = isLocalHost
  ? '/'
  : hasEnvValue(process.env.REACT_APP_APP_URL)
  ? process.env.REACT_APP_APP_URL
  : config.APP_URL;

export const API_URL1 = config.API_URL1;
export const APP_URL1 = config.APP_URL1;

export const APP_CHECKER = config.APP_CHECKER;
export const APP_ID = config.APP_ID;

// optional: default export (legacy support)
export default config;
